import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./styles1/kompd.css";
import kamp from "../images/Kamp.png";
import Button from "react-bootstrap/Button";
import LL from "../images/Group 469 (1).svg";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Kompd() {
  return (
    <>
      <Row xs={1} md={2} className="g-4" id="kampd">
        <Col className="RevleftCol">
          <LazyLoadImage className="img-fluid" alt="" src={kamp} />
        </Col>
        <Col className="RevrightCol">
          <h1 className="Kampd">
            Kampd<em>.</em>
          </h1>
          <p className="phone">
            Kampd, short for "Knowledge Amplified" is a platform for
            professional communities and content. Join the Kampd to build your
            own community around shared interest.
          </p>
          <br />
          <center>
            <hr className="hr" />
          </center>
          <br />
          {/* <center>
          <div className="d-grid gap-2 Revbttn">
            <Button onClick={(e) => {
      e.preventDefault();
      window.location.href='https://www.kampd.com/';
      }} className="Revbtn" size="lg">
              <span className="txt-btn-kompd">Visit the Kampd Website</span><pre><LazyLoadImage className="LL abc" alt="" src={LL}/></pre>
            </Button>
          </div>
          </center> */}
          <div>
            <button
              className="bg-white py-2 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "https://www.kampd.com/";
              }}
              style={{
                borderRadius: "35px",
                border: "1px solid #b8b8b8",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
            >
              <span style={{ paddingLeft: "10px" }}>
                Visit the Kampd Website{" "}
              </span>
              <img
                className=""
                style={{
                  width: "40px",
                  marginRight: "10px",
                  height: "40px",
                  marginLeft: "20px",
                  transform: "rotate(270deg)",
                }}
                alt=""
                src={LL}
              />
            </button>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default Kompd;
